import { roundUpDecimal } from "@/helpers/numberHelpers";
import {
  DataSchemaType,
  DatasetAttributeSchema,
  DatasetDataColumn,
  DatasetDataRowValue,
  DatasetDataType
} from "@/types/dataset";

import { isOrdinalType } from "./dataset";

/** Decimal places kept for a numeric attribute value on the map. */
export const NUMERIC_VALUE_DECIMALS = 3;

const getColumnName = (
  col: DatasetAttributeSchema | DatasetDataColumn
): string => {
  if ("name" in col) return col.name;
  if ("attribute_name" in col) return col.attribute_name;
  throw new Error("Column must have either name or attribute_name");
};

/**
 * The value an attribute takes on the map: ordinal ones keep their value (missing
 * becomes `""`), numeric ones are rounded to {@link NUMERIC_VALUE_DECIMALS}.
 * Anything compared against a feature property must go through this.
 */
export const normalizeAttributeValue = (
  value: DatasetDataRowValue,
  dataType: DataSchemaType | DatasetDataType
): DatasetDataRowValue => {
  if (isOrdinalType(dataType)) return value ?? "";
  return typeof value === "number"
    ? roundUpDecimal(value, NUMERIC_VALUE_DECIMALS)
    : value;
};

export const processValue = (
  value: DatasetDataRowValue,
  column: DatasetAttributeSchema | DatasetDataColumn,
  properties: Record<string, string | number | boolean | null | undefined> = {}
): void => {
  properties[getColumnName(column)] = normalizeAttributeValue(
    value,
    column.data_type
  );
};
